import React  from 'react';
import { Icon, Popover } from 'antd'
import { getProductInfoTranslatedDescriptions } from '../../../common/utils'

export default (props) => {
  const { value } = props;

  if (value.length === 0) {
    return '';
  }

  return (
    <Popover placement="rightTop" title={false} content={getProductInfoTranslatedDescriptions(value).map((description, index) => <p key={index}>{description}</p>)} trigger="click">
      <Icon type="exclamation-circle" theme="filled" style={{ color: 'rgba(219, 94, 94, 1)' }} />
    </Popover>
  );
};
